import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/references/"

class WerkervaringToevoegenSingle extends Component {
    constructor() {
        super()
        this.handleCreateAndEdit = this.handleCreateAndEdit.bind(this)
        this.state = {
            id: 0,
            errors: {}
        }

    }

    emptyForm() {
        this.abbreviation.value = ""
        this.firstName.value = ""
        this.middleName.value = ""
        this.lastName.value = ""
        this.company.value = ""
        this.function.value = ""
        this.phone.value = ""
        this.email.value = ""
        this.reEmail.value = ""
        this.setState({ id: 0 })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data !== undefined && Object.keys(nextProps.data).length !== 0) {
            //let newData = Object.assign({}, nextProps.data)
            //newData.reEmail = nextProps.data.email
            //this.setState({ data: newData })

            let data = nextProps.data
            this.abbreviation.value = data.abbreviation
            this.firstName.value = data.firstName
            this.middleName.value = data.middleName
            this.lastName.value = data.lastName
            this.company.value = data.company
            this.function.value = data.function
            this.phone.value = data.phone
            this.email.value = data.email
            this.reEmail.value = data.email

            this.setState({ id: data.id })
        }
    }

    handleCreateAndEdit(event) {
        event.preventDefault()

        var payload = {}
        payload.abbreviation = this.abbreviation.value
        payload.firstName = this.firstName.value
        payload.middleName = this.middleName.value
        payload.lastName = this.lastName.value
        payload.company = this.company.value
        payload.function = this.function.value
        payload.phone = this.phone.value
        payload.email = this.email.value
        payload.reEmail = this.reEmail.value
        payload.id = this.state.id


        Api.PostApi(FETCH_URL, payload, this.props.history).then(data => {
            if (data !== undefined) {
                Api.print(data)
                this.setState({ errors: data });
            }
            else {
                alert("Referentie added")
                window.location.reload();
            }
        })
    }


    render() {
        Api.print('State')
        Api.print(this.state)
        return (
            <div className="route account">
                <h5>Referentie {this.state.id === 0 ? 'toevoegen' : 'wijzigen'}</h5>
                <Form horizontal onSubmit={this.handleCreateAndEdit}>
                    <FormGroup controlId="ReferentieToevoegenAfkorting">
                        <Col componentClass={ControlLabel} sm={4}>
                            Afkorting
                                </Col>
                        <Col sm={6}>
                            <FormControl name="abbreviation" type="text" inputRef={input => this.abbreviation = input} />
                            {Api.showError(this.state.errors, "abbreviation")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="ReferentieToevoegenVoornaam">
                        <Col componentClass={ControlLabel} sm={4}>
                            Voornaam
                                </Col>
                        <Col sm={6}>
                            <FormControl name="firstName" type="text" inputRef={input => this.firstName = input} />
                            {Api.showError(this.state.errors, "firstName")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="ReferentieToevoegenTussenvoegsel">
                        <Col componentClass={ControlLabel} sm={4}>
                            Tussenvoegsel
                                </Col>
                        <Col sm={6}>
                            <FormControl name="middleName" type="text" inputRef={input => this.middleName = input} />
                            {Api.showError(this.state.errors, "middleName")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="ReferentieToevoegenAchternaam">
                        <Col componentClass={ControlLabel} sm={4}>
                            Achternaam
                                </Col>
                        <Col sm={6}>
                            <FormControl name="lastName" type="text" inputRef={input => this.lastName = input} />
                            {Api.showError(this.state.errors, "lastName")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="ReferentieToevoegenBedrijf">
                        <Col componentClass={ControlLabel} sm={4}>
                            Bedrijf
                                </Col>
                        <Col sm={6}>
                            <FormControl name="company" type="text" inputRef={input => this.company = input} />
                            {Api.showError(this.state.errors, "company")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="ReferentieToevoegenFunctie">
                        <Col componentClass={ControlLabel} sm={4}>
                            Functie
                                </Col>
                        <Col sm={6}>
                            <FormControl name="function" type="text" inputRef={input => this.function = input} />
                            {Api.showError(this.state.errors, "function")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="ReferentieToevoegenTelefoon">
                        <Col componentClass={ControlLabel} sm={4}>
                            Telefoon
                                </Col>
                        <Col sm={6}>
                            <FormControl name="phone" type="text" inputRef={input => this.phone = input} />
                            {Api.showError(this.state.errors, "phone")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="ReferentieToevoegenEmail">
                        <Col componentClass={ControlLabel} sm={4}>
                            E-mail
                                </Col>
                        <Col sm={6}>
                            <FormControl name="email" type="text" inputRef={input => this.email = input} />
                            {Api.showError(this.state.errors, "email")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="ReferentieToevoegenEmailConfirm">
                        <Col componentClass={ControlLabel} sm={4}>
                            E-mail (bevestig)
                                </Col>
                        <Col sm={6}>
                            <FormControl name="reEmail" type="text" inputRef={input => this.reEmail = input} />
                            {Api.showError(this.state.errors, "reEmail")}
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col smOffset={8} sm={2}>
                            <Button type="submit">{this.state.id === 0 ? 'Toevoegen' : 'Wijzigen'}</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default WerkervaringToevoegenSingle;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Werkervaring/WerkervaringReferentieToevoegen.js